<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户ID" class="tiny">
						<el-input style="width: 200px" v-model="searchInfo.userId" placeholder="请输入用户ID"></el-input>
					</el-form-item>
					<el-form-item label="账号" class="tiny">
						<el-input style="width: 200px" v-model="searchInfo.username" placeholder="请输入用户账号"></el-input>
					</el-form-item>
					<el-form-item label="手机号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入用户手机号"></el-input>
					</el-form-item>
					<!-- <el-form-item label="时间">
                        <div class="block">iphone
                            <el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
                                :default-time="['00:00:00', '23:59:59']">
                            </el-date-picker>
                        </div>
                    </el-form-item> -->
					<!-- <el-form-item label="钱包地址" class='tiny'>
                        <el-input style="width: 200px;" v-model="searchInfo.address" placeholder="请输入钱包地址"></el-input>
                    </el-form-item> -->

					<el-form-item label="资产名称" class='tiny'>
						<el-select v-model="searchInfo.integralId" class="big" placeholder="请选择" clear>
							<el-option v-for="item in integralList" :key="item.id" :value="item.id" :label="item.name">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button> -->
							<!-- <el-button type="primary" @click="editialogVisible()">新增用户
                            </el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<!--   <div style="margin: 20px;">
            <div style="font-size: 14px;display: flex;justify-content: start;align-items: center;">
                <div>
                    <span style="font-weight: bold;">统计</span><span style="font-size: 12px;">(资产名称必选)</span>：
                </div>
                <div>
                    总资产: {{allData?allData:0 |intToFloatfour|cutZero}}
                </div>
            </div>
        </div> -->
		<div
			style="margin: 20px;font-size: 14px;display: flex;flex-direction: row;justify-content: space-between;align-items: center;width: 600px;">
			<div>
				<!-- 余额: {{homedata?homedata.sum.yue:0}} -->
			</div>
			<div>
				<!-- 红包: {{homedata.sum.hongbao?homedata.sum.yue:0} -->
			</div>
		</div>
		<div style="margin: 20px">
			<div style="font-size: 14px;display: flex;justify-content: start;align-items: center;">
				<div><span style="font-weight: bold">统计</span>：</div>
				<div>
					总数量: {{ allData ? allData : 0 | intToFloatfour | cutZero }}
				</div>
			</div>
		</div>
		<el-table :data="propertyList.list" stripe style="width: 100%;" :header-cell-style="headClass"
			v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<!-- <el-table-column prop="id" label="序号" sortable align="center">
            </el-table-column> -->
			<el-table-column prop="userId" label="用户ID" sortable align="center">
			</el-table-column>
			<el-table-column prop="username" label="账号" align="center">
			</el-table-column>
			<el-table-column prop="nickname" label="昵称" align="center">
			</el-table-column>
			<el-table-column prop="phone" label="手机号" align="center">
			</el-table-column>
			<el-table-column prop="introduce" label="资产名称" align="center">
			</el-table-column>
			<el-table-column prop="total" label="资产总和" align="center">
			</el-table-column>
			<!-- <el-table-column prop="cumulative" label="总资产累计" align="center">
            </el-table-column> -->
			<!-- <el-table-column prop="inUseCnt" label="可使用资产" align="center">
            </el-table-column> -->
			<el-table-column prop="lockCnt" label="冻结资产" align="center">
			</el-table-column>
			<!-- <el-table-column prop="address" label="钱包地址" align="center" :show-overflow-tooltip="true">
            </el-table-column> -->
			<el-table-column prop="createDate" label="创建时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
		</el-table>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<el-pagination style="margin: 20px;" background :current-page="propertyList.list.pageNum"
				@current-change="pageChange" @size-change="handleSizeChange"
				layout="total, sizes, prev, pager, next, jumper" :total="propertyList.list.total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				homedata: {},
				loading: false,
				propertyList: [], //资产列表
				dialogVisible: false,
				integralList: [],
				integralId: "", //积分id
				appropriation: "",
				ids: '', //授权用户id
				userData: [{}], //用户角色列表
				userDataList: [], //用户角色列表选中的
				formLabelWidth: "200px",
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {},
				allData: {}
			};
		},
		filters: {
			intToFloatfour(val) {
				return (Math.floor(Number(val) * 10000) / 10000).toFixed(4)
			},
			cutZero(old) {
				//拷贝一份 返回去掉零的新串
				old = old + ""
				var newstr = old
				//循环变量 小数部分长度
				var i = 0
				var leng = old.length - old.indexOf(".") - 1
				//判断是否有效数
				if (old.indexOf(".") > -1) {
					//循环小数部分
					for (i = leng; i > 0; i--) {
						//如果newstr末尾有0
						if (newstr.lastIndexOf("0") > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
							var k = newstr.lastIndexOf("0")
							//如果小数点后只有一个0 去掉小数点
							if (newstr.charAt(k - 1) == ".") {
								return newstr.substring(0, k - 1)
							} else {
								//否则 去掉一个0
								newstr = newstr.substring(0, k)
							}
						} else {
							//如果末尾没有0
							return newstr
						}
					}
				}
				return old
			}
		},
		methods: {
			getHomeDate() {
				this.$api.homeDate().then((res) => {
					if (res.state == 'success') {
						this.homedata = res.data
					}
				})
			},
			downloadFile() {
				let data = {
					phone: this.searchInfo.phone ? this.searchInfo.phone : "",
					integralId: this.searchInfo.integralId ? this.searchInfo.integralId : "",
					userId: this.searchInfo.userId ? this.searchInfo.userId : "",
					username: this.searchInfo.username ? this.searchInfo.username : "",
				};
				//   console.log(data);
				this.$api.memberExcel(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "会员资产列表" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getpropertyList()
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getpropertyList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getpropertyList()
			},
			getpropertyList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					phone: this.searchInfo.phone,
					integralId: this.searchInfo.integralId,
					userId: this.searchInfo.userId,
					username: this.searchInfo.username,
				}
				// console.log(data)
				this.$api.getUserPropertyList(data).then((res) => { // 管理列表
					if (res.state == 'success') {
						this.propertyList = res.data
						this.allData = res.data.total
						this.loading = false
					}
				})
				// this.$api.getStatisticsUserPropertyList(data).then((res) => { // 管理列表
				//     if (res.state == 'success') {
				//         this.allData = res.data
				//     }
				// })

			},
		},
		created() {
			this.getHomeDate()
			this.getpropertyList();
			this.$api.getIntegralList().then((res) => {
				if (res.state == 'success') {
					this.integralList = res.data
				}
			})
		}
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>
